import { __rest, __assign } from '../../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import SvgKebab24 from '../../../icons/interface/Kebab24.js';

var OptionsHeader = function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (jsx("th", __assign({}, props, { className: classNames('position-relative table-cell-square', className) }, { children: jsx(SvgKebab24, { className: "position-absolute start-50 translate-middle-x opacity-40 table-cell-square-icon" }) })));
};

export { OptionsHeader };
